import { useState } from "react";
import { CalendarDays, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Panel } from "@/components/Panel";
import { http, formatError } from "@/lib/api";

export const CalendarPanel = ({ initial }) => {
  const [url, setUrl] = useState(initial || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await http.put("/settings", { calendar_url: url });
      const { data } = await http.get("/calendar/today");
      toast.success(url ? `Calendar linked · ${data.events.length} event(s) today` : "Calendar disconnected");
      if (data.error) toast.error(data.error);
    } catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };
  return (
    <Panel label="Calendar Sync" title="Private Calendar Link" testId="settings-calendar-panel">
      <p className="text-slate-400 text-sm mb-4">Paste your secret iCal/ICS address (Google: Settings → your calendar → "Secret address in iCal format"; Outlook: Publish calendar → ICS). JARVIS reads today's meetings into your briefings.</p>
      <input className="hud-input mb-4 font-mono-hud !text-[12px]" placeholder="https://calendar.google.com/calendar/ical/…/basic.ics" value={url} onChange={(e) => setUrl(e.target.value)} data-testid="settings-calendar-url-input" />
      <button className="hud-btn" onClick={save} disabled={busy} data-testid="settings-calendar-save-button">{busy ? <Loader2 size={14} className="animate-spin" /> : <CalendarDays size={14} />} Save & Test</button>
    </Panel>
  );
};
